import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class ReportsHistoricsHeader extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    handleExport: PropTypes.func.isRequired,
    handleExportXLSX: PropTypes.func.isRequired,
    handleExportPDF: PropTypes.func.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canAdd: false,
  };

  handleExport = (e) => {
    e.preventDefault();
    this.props.handleExport();
  };

  handleExportXLSX = (e) => {
    e.preventDefault();
    this.props.handleExportXLSX();
  };

  handleExportPDF = (e) => {
    e.preventDefault();
    this.props.handleExportPDF(this.props.t);
  };

  render = () => {
    return <Common.Header title={this.props.t('reports.historics.title')}></Common.Header>;
  };
}

export default translate()(ReportsHistoricsHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/historics/HistoricsReportHeader.js